/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_nearby_enemy = require('./Q_nearby_enemy');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_injury_nearby = function (actor, battleState, buffNode) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_nearby_enemy(actor, battleState, buffNode);

  if (BattleCalc.getEquippedAbility(actor, 'healing_prayer')) {
    node.branches[node.NO] = new UseAbility(actor, 'healing_prayer');
  } else {
    node.branches[node.NO] = buffNode;
  }

  node.yesNoEvalFunction = function (target) {
    return BattleCalc.boardDistance(this.actor, target) < 3;
  };

  return node;
};
module.exports = Q_injury_nearby;
